import { colors } from './colors';

export const border = {
  disabled: colors.gray['03'],
};
